class ProductTestimonialSlider extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.slides = Array.from(this.querySelectorAll('[data-slide]'));
    this.slidesContainer = this.querySelector('.wp-product-testimonial-slider__slides');
    this.buttons = Array.from(this.querySelectorAll('[data-slide-button]'));
    this.previousButton = this.querySelector('[data-slide-previous]');
    this.nextButton = this.querySelector('[data-slide-next]');
    this.index = 0;
    this.delay = Number(this.dataset.autoplay) || 5500;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.onResize = this.updateHeight.bind(this);

    this.buttons.forEach((button, index) => {
      button.addEventListener('click', () => {
        this.show(index);
        this.restart();
      });
    });

    this.previousButton?.addEventListener('click', () => {
      this.show((this.index - 1 + this.slides.length) % this.slides.length);
      this.restart();
    });
    this.nextButton?.addEventListener('click', () => {
      this.show((this.index + 1) % this.slides.length);
      this.restart();
    });

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());
    window.addEventListener('resize', this.onResize);
    this.updateHeight();
    requestAnimationFrame(() => this.updateHeight());
    this.start();
  }

  disconnectedCallback() {
    this.stop();
    window.removeEventListener('resize', this.onResize);
  }

  show(index) {
    this.index = index;
    this.slides.forEach((slide, slideIndex) => {
      const active = slideIndex === index;
      slide.classList.toggle('is-active', active);
    });
    this.buttons.forEach((button, buttonIndex) => {
      const active = buttonIndex === index;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    this.updateHeight();
  }

  updateHeight() {
    const activeSlide = this.slides[this.index];
    if (!activeSlide || !this.slidesContainer) return;
    this.slidesContainer.style.setProperty('--wp-testimonial-height', `${activeSlide.offsetHeight}px`);
  }

  start() {
    if (this.reduceMotion || this.timer || this.slides.length < 2) return;
    this.timer = window.setInterval(() => this.show((this.index + 1) % this.slides.length), this.delay);
  }

  stop() {
    if (!this.timer) return;
    window.clearInterval(this.timer);
    this.timer = null;
  }

  restart() {
    this.stop();
    this.start();
  }
}

if (!customElements.get('product-testimonial-slider')) {
  customElements.define('product-testimonial-slider', ProductTestimonialSlider);
}
